export const hasActiveMalwareScan = (attachments: { malware_scan_status?: string }[] = []): boolean =>
  attachments.some((a) => a.malware_scan_status === 'PENDING');
